import { render, staticRenderFns } from "./MessageNotificationList.vue?vue&type=template&id=63fe6b90&scoped=true"
import script from "./MessageNotificationList.vue?vue&type=script&lang=js"
export * from "./MessageNotificationList.vue?vue&type=script&lang=js"
import style0 from "./MessageNotificationList.vue?vue&type=style&index=0&id=63fe6b90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fe6b90",
  null
  
)

export default component.exports